/**************************************************
 * Nombre:       Blog_Contenido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Blog_Imagen_Texto from "./SubComponentes/Blog_Imagen_Texto";
import Blog_Recientes from "./SubComponentes/Blog_Recientes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Blog_Contenido = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        direction={'row-reverse'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>
                            <Blog_Imagen_Texto item={item}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start', mt:sCell ? 2 : 0}}>
                            <Blog_Recientes/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Blog_Contenido  